export const TIMELINE_EVENT_SLIDE_YEAR_CHANGE = 'on-timeline-slide-year-change';
